import { Directive, ElementRef, HostBinding } from '@angular/core';

@Directive({
  selector: '[appUploaderPlaceholder]'
})
export class UploaderPlaceholderDirective {

  @HostBinding('style.position')
  position = 'absolute';

  @HostBinding('style.top')
  top = 0;

  @HostBinding('style.left')
  left = 0;

  @HostBinding('style.padding')
  padding = '1rem';

  @HostBinding('style.width')
  width = '100%';

  @HostBinding('style.height')
  height = '100%';

  @HostBinding('style.background-color')
  backgroundColor = 'inherit';

  constructor(public elementRef: ElementRef) {
  }
}
